module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_04_american-village-076dbd61131fc307aba8570ab7473910.jpg";